var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18.423 18.423"}},[_c('g',[_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M17.362 17.363L1.061 1.06"}}),_vm._v(" "),_c('path',{attrs:{"d":"M1.142 16.485l15.36-15.323"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }